/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailedPspNotificationDto
 */
export interface FailedPspNotificationDto {
    /**
     * 
     * @type {Date}
     * @memberof FailedPspNotificationDto
     */
    created: Date;
    /**
     * 
     * @type {number}
     * @memberof FailedPspNotificationDto
     */
    pspNotificationId: number;
    /**
     * 
     * @type {Date}
     * @memberof FailedPspNotificationDto
     */
    pspNotificationTimestamp: Date;
    /**
     * 
     * @type {number}
     * @memberof FailedPspNotificationDto
     */
    retryCount: number;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    type: string;
    /**
     * 
     * @type {Date}
     * @memberof FailedPspNotificationDto
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    latestFailureReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    payload?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailedPspNotificationDto
     */
    stackTrace?: string | null;
}

/**
 * Check if a given object implements the FailedPspNotificationDto interface.
 */
export function instanceOfFailedPspNotificationDto(value: object): value is FailedPspNotificationDto {
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('pspNotificationId' in value) || value['pspNotificationId'] === undefined) return false;
    if (!('pspNotificationTimestamp' in value) || value['pspNotificationTimestamp'] === undefined) return false;
    if (!('retryCount' in value) || value['retryCount'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function FailedPspNotificationDtoFromJSON(json: any): FailedPspNotificationDto {
    return FailedPspNotificationDtoFromJSONTyped(json, false);
}

export function FailedPspNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailedPspNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'created': (new Date(json['created'])),
        'pspNotificationId': json['pspNotificationId'],
        'pspNotificationTimestamp': (new Date(json['pspNotificationTimestamp'])),
        'retryCount': json['retryCount'],
        'type': json['type'],
        'updated': (new Date(json['updated'])),
        'latestFailureReason': json['latestFailureReason'] === undefined ? undefined : json['latestFailureReason'] === null ? null : json['latestFailureReason'],
        'payload': json['payload'] === undefined ? undefined : json['payload'] === null ? null : json['payload'],
        'stackTrace': json['stackTrace'] === undefined ? undefined : json['stackTrace'] === null ? null : json['stackTrace'],
    };
}

export function FailedPspNotificationDtoToJSON(json: any): FailedPspNotificationDto {
    return FailedPspNotificationDtoToJSONTyped(json, false);
}

export function FailedPspNotificationDtoToJSONTyped(value?: FailedPspNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'].toISOString(),
        'pspNotificationId': value['pspNotificationId'],
        'pspNotificationTimestamp': value['pspNotificationTimestamp'].toISOString(),
        'retryCount': value['retryCount'],
        'type': value['type'],
        'updated': value['updated'].toISOString(),
        'latestFailureReason': value['latestFailureReason'],
        'payload': value['payload'],
        'stackTrace': value['stackTrace'],
    };
}

